import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { from, Observable } from 'rxjs';
import { mergeMap, tap } from 'rxjs/operators';
import { AuthService } from 'src/app/core/authentication/services/auth.service';


@Injectable()
export class TokenInterceptor implements HttpInterceptor {
	constructor(
		public auth: AuthService
	) { }

	intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		// We retrieve the token, if any
		return this.getAuthToken()
			.pipe(
				mergeMap(token => {
					let newHeaders = req.headers;
					if (token) {
						newHeaders = newHeaders.append('authtoken', token);
					}

					const authReq = req.clone({
						setHeaders: {
							Authorization: `Bearer ${token}`,
							'Cache-Control': 'no-cache',
							'Pragma': 'no-cache',
							'If-Modified-Since': '0',
						},
					});

					// Return an Observable that will run the request
					// or pass it to the next interceptor if any
					return next.handle(authReq)
						.pipe(
							tap(
								() => { },
								async (error) => { await this.handleError(error); }
							)
						);
				})
			);
	}

	async handleError(error: any): Promise<void> {
		if (error instanceof HttpErrorResponse) {
			if (error.status !== 401) {
				return;
			}

			await this.auth.logout();
		}
	}

	getAuthToken(): Observable<string> {
		return from(this.auth.getAuthToken());
	}
}
